import {
  AddAssetToShiftRequest,
  AddFolderToAsset,
  Asset,
  AssetCreateRequest,
  AssetMainDashboardSetting,
  AssetTreeView,
  AssetUpdateRequest,
  RemoveAssetFromShiftRequest,
  UpdateMainDashboardForAssetRequest,
} from '../../types/app/asset.types';
import { Shift } from '../../types/app/shifts.types';
import { api } from '../core/api';

export const getAssetList = (id?: number) =>
  id
    ? api.get<Asset[]>(`Asset/GetList?parentId=${id}`).then((res) => res.data)
    : api.get<Asset[]>('Asset/GetList').then((res) => res.data);

export const getListWithDashboardsFiltered = (groupId?: number) =>
  groupId
    ? api
        .get<Asset[]>(`Asset/GetListWithDashboardsFiltered?groupId=${groupId}`)
        .then((res) => res.data)
    : api.get<Asset[]>('Asset/GetListWithDashboardsFiltered').then((res) => res.data);

export const getListFiltered = (groupId?: number, parentId?: number) =>
  api
    .get<Asset[]>(
      groupId === undefined
        ? `Asset/GetListFiltered`
        : `Asset/GetListFiltered` +
            (groupId ? `?groupId=${groupId}` : '') +
            (parentId ? `&parentId=${parentId}` : ''),
    )
    .then((res) => res.data);

export const getAsset = (id: number) =>
  api.get<Asset>(`Asset/GetItem?id=${id}`).then((res) => res.data);

export const assetGetTreeView = (id: number) =>
  api.get<AssetTreeView>(`Asset/GetAssetTreeView?id=${id}`).then((res) => res.data);

export const getCount = (topOnly: boolean) =>
  api.get<number>(`Asset/GetCount?topOnly=${topOnly}`).then((res) => res.data);

export const updateAsset = (data: AssetUpdateRequest) =>
  api.put(`Asset/UpdateItem`, data).then((res) => res.data);

export const createAsset = (data: AssetCreateRequest) =>
  api.post(`Asset/CreateItem`, data).then((res) => res.data);

export const deleteAsset = (id: number) => api.delete<Asset>(`Asset/DeleteItem/?id=${id}`).then();

export const getShiftsForAsset = (id: number) =>
  api.get<Shift[]>(`Asset/GetShiftsForAsset?id=${id}`).then((res) => res.data);

export const getCurrentShiftForAsset = (id: number) =>
  api.get<Shift>(`Asset/GetCurrentShiftForAsset?id=${id}`).then((res) => res.data);

export const addAssetToShift = (data: AddAssetToShiftRequest) =>
  api
    .post(`Asset/AddAssetToShift?id=${data.id}&shiftId=${data.shiftId}`, data)
    .then((res) => res.data);

export const removeAssetFromShift = (data: RemoveAssetFromShiftRequest) =>
  api.delete(`Asset/RemoveAssetFromShift?id=${data.id}&shiftId=${data.shiftId}`).then();

export const getMainDashBoardSettingForAsset = (id: number) =>
  api
    .get<AssetMainDashboardSetting>(`Asset/GetMainDashBoardSettingForAsset?id=${id}`)
    .then((res) => res.data);

export const updateMainDashBoardSettingForAsset = (data: UpdateMainDashboardForAssetRequest) =>
  api
    .put<AssetMainDashboardSetting>(`Asset/UpdateMainDashBoardSettingForAsset`, data)
    .then((res) => res.data);

export const grafanaAddFolderForAsset = (data: AddFolderToAsset) =>
  api
    .post(
      `Asset/GrafanaAddFolderForAsset?assetId=${data.assetId}&folderName=${data.folderName}`,
      data,
    )
    .then((res) => res.data);
